// export const baseURL = "https://qvrewardsstaging.loyaltyplatform.net";
export const baseURL = "https://qvrewardsapp.loyaltyplatform.net"; //production

export const googleMapKey = "AIzaSyCJPORuDNEwsIMAJzAAUTtq7SErRR552ok";
export const RECAPTCHA_KEY = "6LeaWhIpAAAAAI684oQ2ylYriOOKkgcjCeialS3B";
